import React, { useEffect, useState } from 'react';
import { Grid, IconButton } from '@mui/material';
import { Info } from '@mui/icons-material';
import { connect } from 'react-redux';
import RefuelingTankerComponent from '../../components/refueling_tanker';
import * as petrolStation from '../../appRedux/actions/petrol_station';
import SalesDetails from '../../components/sales_details';
import BlankPage from '../../components/blank_page';
import IntlMessages from '../../util/IntlMessages';
import Comeback from '../../components/comeback';
import * as router from '../../constants/router';
import * as constants from '../../constants';
import Alert from '@mui/material/Alert';

function RefuelingTanker(props) {
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    props.petrolStationRefuelTankerByOperatorAction();
  }, []);

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={6} md={6}>
          <Comeback
            title={<IntlMessages id="refuelingTanker" />}
            redirectLink={router.SALES}
          />
        </Grid>
        <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
          <IconButton onClick={() => setShowDetails(!showDetails)}>
            <Info />
          </IconButton>
        </Grid>
      </Grid>

      {props.list.length === 0 ? (
        <BlankPage type={constants.BLANK_PAGE_REFUELING_TANKER} />
      ) : (
        props.list.map((refueling, index) => (
          <RefuelingTankerComponent key={index} {...refueling} />
        ))
      )}
      <div style={{ marginTop: 50 }}>
        <SalesDetails
          type="fuel"
          showDetails={showDetails}
          setShowDetails={() => setShowDetails(!showDetails)}
        />
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    list: state.field.list,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    petrolStationRefuelTankerByOperatorAction: () =>
      dispatch(petrolStation.petrolStationRefuelTankerByOperatorAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RefuelingTanker);
